import React from "react";
import {  useDispatch, useSelector } from "react-redux";
import { breakUpdate } from "../../api/breakAPI";
import Loader from "../Loader";

function Notes() {
    const dispatch = useDispatch();
    const breakDetail = useSelector(state => state.breaks.breakDetail);
    const loading = useSelector(state => state.breaks.loading)
    const token = useSelector(state => state.user.token)
    const [edit, setEdit] = React.useState(false);
    const [notes, setNotes] = React.useState(breakDetail.notes)

    const handleEdit = () => {
        setEdit(true);
    }

    const handleModify = (event) => {
        setNotes(event.target.value)
    }

    const handleUpdate = (event) => {
        event.preventDefault();
        const submitData = {
            notes: notes
        }
        dispatch(breakUpdate({id: breakDetail._id, token, submitData}))
        setEdit(false);
    }

    return(
        <div className="">
            <h2>Notes</h2>
            <p className='description m-3'>
                You can add any notes about the break here, especially about conditions that don't show up with the buoy data (crowd, accessibility, etc.)
            </p>

            {!loading ? <div>
                {edit ? <textarea value={notes} onChange={(event) => handleModify(event)} className="bg-gray-100 p-4 mb-6 rounded shadow w-11/12 whitespace-pre-wrap"></textarea> : 
                <p className="bg-gray-100 p-4 mb-6 rounded shadow w-11/12 mx-auto whitespace-pre-wrap">{breakDetail.notes}</p>}
            </div> : <div className="m-4"><Loader /></div>}

            {edit ? <button className="btn-primary" onClick={(event) => handleUpdate(event)}>Update Notes</button> :
            <button className="btn-secondary" onClick={handleEdit}>Modify Notes</button>}
        </div>
    )

}

export default Notes;